import QuestionHeader from "../component/QuestionHeader";
import QuestionFooter from "../component/QuestionFooter";
import {useEffect, useState} from "react";
import ListenAudio from "../../../../components/Audio/ListenAudio";
import {DetButton} from "../../../../components/Form/Button/FormButton";
import { useParams} from "react-router-dom";
import {useQuestion} from "../../../../redux/Reducers/QuestionReducer";
import useForm from "../../../../hooks/useForm";
import URLS from "../../../../API/Axios/URLS";

function AudioComponent({choice, index, current, setIndex}) {
    return (
        <div className={"flex flex-col items-center w-full  gap-4"}>
            {
                index === current ?
                    <>
                        <ListenAudio audio={choice?.audioUrl} className={"flex-1"}
                                     replayOnce
                        />
                        <DetButton className={"w-full lg:w-1/4 py-2 sm:rounded-md md:rounded-md"}
                                   onClick={() => {
                                       setIndex(index + 1)
                                   }}
                        >
                            Next
                        </DetButton>
                    </> :
                    <p className={"font-semibold text-bawa"}>
                        {choice?.audioTranscript}

                    </p>
            }

        </div>
    )
}

function MapOptions({obj, answer, index, setAnswer, choiceIndex, setIndex, maxIndex}) {
    let choices = [...obj.choices]
    // sort choices by id
    // choices.sort((a,b)=>{
    //     return a.id.charCodeAt(0) - b.id.charCodeAt(0)
    // })

    return <div className={"flex flex-col  items-center justify-center"}>
        {
            choices?.map((choice, index2) => {
                let answerIndex = choiceIndex
                if (choiceIndex % 2 === 0) {
                    answerIndex = choiceIndex / 2
                } else {
                    let temp = choiceIndex / 2
                    answerIndex = temp + 1
                }
                return (
                    <div className={`w-full my-1 flex flex-col cursor-pointer
                        ${index !== choiceIndex && choice.correct === "1" ? "bg-tertiary-200 pointer-events-none" : ""}
                        ${index !== choiceIndex && answer[answerIndex] === choice?.options[0] && choice.correct === "0" ? "bg-red-200 pointer-events-none" : ""}
                        ${index !== choiceIndex && answer[answerIndex] !== choice?.options[0] && choice.correct === "0" ? "hidden" : ""}
                        
                        
                        `}

                    >

                        {/*    checkbox*/}
                        <div className={"flex flex-1 items-center"}
                             onClick={() => {
                                 //     click the first child
                                 document.getElementById(`choice-${choiceIndex}-id-${choice.id}`).click()

                             }}
                        >
                            <input
                                type={"radio"}
                                id={`choice-${choiceIndex}-id-${choice.id}`}
                                name={`choice-${choiceIndex}-id-${choice.id}`}
                                checked={answer[answerIndex] === choice?.options[0]}
                                onChange={(e) => {

                                    let temp = [...answer]
                                    temp[answerIndex] = e.target.checked ? choice?.options[0] : ""
                                    setAnswer(temp)
                                }}
                                className={"w-4 h-4 rounded-md border border-gray-400 mr-2"}/>
                            <p className={"text-bawa"}>{String.fromCharCode(65 + index2)}) {choice?.options[0]}</p>
                        </div>


                    </div>
                )
            })
        }
        {
            index === choiceIndex &&
            <DetButton className={"w-full lg:w-1/4 self-center mt-5 py-2 sm:rounded-md md:rounded-md"}
                       onClick={() => {
                           setIndex(index + 1)
                       }}
            >
                Next
            </DetButton>


        }
    </div>


}

function MapQuestion({question, answer, setAnswer}) {
    const [currentIndex, setCurrentIndex] = useState(0)
    const [maxIndex] = useState(question?.picks?.length - 1)
    const [noMore, setNoMore] = useState(false)
    const [picks, setPicks] = useState([])


    useEffect(() => {
        if (currentIndex > maxIndex) {
            setNoMore(true)

        } else {
            let temp = []

            for (let i = 0; i <= currentIndex; i++) {
                temp.push(question.picks[i])
            }

            setPicks(temp)
        }
    }, [currentIndex])

    return (
        <div className={"w-2/3 flex flex-col justify-center gap-2 "}>
            <p className={"font-bold text-center text-bawa"}>You will participate in a conversation about the scenario
                below.</p>
            <p className={"w-2/3 text-base text-wrap self-center font-semibold text-center"}>{question?.scenario}</p>
            <line className={"line"}/>
            {
                picks?.map((choice, choiceIndex) => {
                    if (choice.type % 2 === 0) {
                        return <div className={"border-b-2 py-5"}>
                            <AudioComponent choice={choice} index={currentIndex} current={choiceIndex}
                                            setIndex={setCurrentIndex}
                                            key={choiceIndex}/>
                        </div>
                    } else {

                        return <div className={"border-b-2 py-5"}>
                            <MapOptions obj={choice} answer={answer} setAnswer={setAnswer} choiceIndex={choiceIndex}
                                        index={currentIndex}
                                        setIndex={setCurrentIndex}
                                        key={choiceIndex}
                                        maxIndex={maxIndex}

                            />
                        </div>
                    }
                })}
            {
                noMore &&
                <>
                    <p className={"font-bold text-center text-xl"}>Task Completed.</p>
                </>
            }
        </div>
    )
}

export default function ListenAndRespond({className, ...props}) {
    const [answer, setAnswer] = useState([])
    const {id} = useParams()
    const {question, questionActions, isLoading} = useQuestion()
    const [dataLoaded, setDataLoaded] = useState(false)
    const [form, error, loading, setFormData, actions] = useForm({
        questionId: id,
        answer: "lorum ipsum dolor sit amet  You are in your final year of school and need to decide on a thesis topic. You want input from your classmate, who is also getting a degree in dance. You are considering doing your thesis on the rise of hip hop dance in the United States in the 1980s.",
    }, true)
    const [haseParticipated, setHasParticipated] = useState(false)
    useEffect(() => {
        questionActions.loadQuestions(id)
        setDataLoaded(true)

    }, []);
    useEffect(() => {
        if (question?.picks && dataLoaded) {
            let temp = []
            for (let i = 0; i < question?.picks?.length; i++) {
                if (question?.picks[i].type === 1) {
                    temp.push("")
                }
            }
            setAnswer(temp)
        }

    }, [dataLoaded, question]);


    async function submitAnswer() {
        actions.post(URLS.genericQuestionView).then(response => {
            setHasParticipated(true)
        })
    }

    return (
        <div className={`rounded-lg shadow-lg p-4 ${className}`}>
            <QuestionHeader  {...question}/>
            {
                dataLoaded && question?.picks &&
                <div className={" flex flex-col items-center p-2 py-8 justify-center gap-8"}>
                    <MapQuestion question={question} answer={answer} setAnswer={setAnswer}/>

                </div>
            }
            <QuestionFooter
                submitText={"Practiced +1"}
                onClick={submitAnswer}
                loading={loading}
                disabled={haseParticipated}
                className={"mx-4 my-2"}/>


        </div>

    )
}
